/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createServiceStateControlChipStyles = makeStyles(() => ({
  chipStatus: {
    marginLeft: '20px',
    fontFamily: 'monospace',
    transition: 'max-width 0.3s ease-out, padding 0.3s ease-out, margin 0.3s ease-out',
  },
  chipStopIcon: {
    '&:hover': {
      color: `#E3E3E3!important`,
    },
  },
}));
